/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { regionsControllerCreate } from "./regionsControllerCreate";
import { regionsControllerFindAll } from "./regionsControllerFindAll";
import { regionsControllerFindOne } from "./regionsControllerFindOne";
import { regionsControllerRemove } from "./regionsControllerRemove";
import { regionsControllerUpdate } from "./regionsControllerUpdate";

export function regionsService() {
  return { regionsControllerCreate, regionsControllerFindAll, regionsControllerFindOne, regionsControllerUpdate, regionsControllerRemove }
}